import { notification as antdNotification } from 'antd';

const addKey = (notificationConfig) => {
  const { key } = notificationConfig;
  let newNotificationConfig = notificationConfig;
  // if key is missing add key
  if (!key) {
    newNotificationConfig = {
      ...notificationConfig,
      placement: 'top',
      key: typeof notificationConfig.message === 'string' ?
        notificationConfig?.message?.replace(/ /g, '_') :
        'notificationKey',
    };
  }
  return newNotificationConfig;
};

const createConfig = (notificationConfig) => {
  const fullConfig = addKey(notificationConfig);
  return fullConfig;
};

const notification = {
  info: (notificationConfig) => {
    const config = createConfig(notificationConfig);
    antdNotification.info(createConfig(config));
  },
  success: (notificationConfig) => {
    const config = createConfig(notificationConfig);
    antdNotification.success(createConfig(config));
  },
  warning: (notificationConfig) => {
    const config = createConfig(notificationConfig);
    antdNotification.warning(createConfig(config));
  },
  error: (notificationConfig) => {
    const config = createConfig(notificationConfig);
    antdNotification.error(createConfig(config));
  },
  destroy: (notificationConfig) => {
    if (notificationConfig) {
      antdNotification.destroy(notificationConfig);
    } else {
      antdNotification.destroy();
    }
  },
  config: (notificationConfig) => {
    antdNotification.config(notificationConfig);
  },
  open: (notificationConfig) => {
    antdNotification.open(notificationConfig);
  },
  useNotification: () => {
    antdNotification.useNotification();
  },
};

export default notification;
